const profileStaffEN = {
	header: {
		title: "Shop Profile",
		preview: "Preview",
		edit: "Edit",
	},

	images: {
		addPhoto: "Add Photo",
		reviews: "reviews",
		noPhotos: "No photos yet",
		title: "Images",
		makeCover: "Set as cover",
		replace: "Replace",
		delete: "Delete",
		cover: "Cover",
		noImageSelected: "No image selected",
		noImage: "No image",
		confirmDelete: "Are you sure you want to delete this image?",
	},

	services: {
		title: "Services",
		add: "+ Add",
		empty: "No services listed yet.",
		emptyCategory: "No services in this category",
		name: "Service name",
		price: "Price",
		hours: "Hours",
		minutes: "Minutes",
		description: "Description",
		category: "Category",
		placeholderName: "Service name",
		placeholderDescription: "Service description",
		homeService: "Home service",
		inShop: "In shop",
		transitTimeLabel: "Transit time before service (minutes)",
		servicesIOffer: "Services I Offer",
		addServices: "+ Add services",
		servicesCount: "services",
	},

	actions: {
		saveChanges: "Save Changes",
		cancel: "Cancel",
	},

	errors: {
		fillAllFields: "Please fill in all required fields.",
	},

	staffInfo: {
		title: "Edit Profile",
		firstName: "First Name",
		lastName: "Last Name",
		bio: "Bio",
		phone: "Phone Number",
	},

	sidebar: {
		editServices: "Edit Services",
		location: {
			title: "Location",
		},
		contact: {
			title: "Contact Details",
			phone: "Phone Number",
			email: "Email",
			noPhone: "No phone available",
			noEmail: "No email provided",
			socialTitle: "Social Media",
			website: "Website",
			instagram: "Instagram",
			facebook: "Facebook",
			tiktok: "TikTok",
		},
		hours: {
			title: "Opening Hours",
			show: "Show more hours",
			hide: "Hide hours",
			closed: "Closed",
			edit: "Edit Hours",
			addHours: "Add opening hours",
		},
		staff: {
			title: "Team",
			edit: "Manage Team",
			roles: {
				admin: "Admin",
				staff: "Staff",
				owner: "Owner",
			},
			noStaff: "No team members yet.",
			addStaff: "Invite Team Member",
			remove: "Remove",
			editRole: "Change Role",
		},
	},

	modal: {
		shopInfo: {
			title: "Shop Information",
			subTitle: "Details",
			name: "Shop Name",
			description: "Description",
			address: "Address",
			city: "City",
			country: "Country",
		},
		contact: {
			title: "Contact Details",
			description: "Update phone, email and social media links.",
		},
		hours: {
			title: "Business Hours",
			description: "Set open and close times for each day.",
			open: "Open",
			close: "Close",
			closed: "Closed",
		},
		team: {
			title: "Team Members",
			description: "Manage staff members and their roles.",
			addButton: "Invite Member",
			close: "Close",
			save: "Save",
		},
	},

	categories: {
		cannotDeleteWithServices: "Remove or move all services before deleting this category",
		addCategory: "Add category",
		newCategory: "New category",
	},

	addAddress: "Add address",
	addServices: "+ Add or edit services",
	addFirstServices: "+ Add your first service",
	addShopName: "Add shop name",
	noReviewsyet: "No reviews yet",
	addAttributes: "+ Add attributes",
	addDescription: "Add a short description about your business",
};

export default profileStaffEN;